import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';

import GalleryContainer from './containers/GalleryContainer';
import AdminPage from './components/AdminPage/AdminPage';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onSetLogo = logo => {
    this.setState({ logo });
  };

  onSetBackground = background => {
    this.setState({ background });
  };

  render() {
    const { logo, background } = this.state;
    return (
      <BrowserRouter>
        <div className="app">
          {/*<Route exact path="/" render={() => <Redirect to="/create_gallery/" />} />*/}
          <Route exact path="/" render={() => <h1>Welcome to Photo Gallery!</h1>} />
          <Route exact path="/create_gallery/" component={AdminPage} />

          <Route
            exact
            path="/gallery/:id"
            render={routeProps => (
              <GalleryContainer
                {...routeProps}
                logo={logo}
                background={background}
                onSetLogo={this.onSetLogo}
                onSetBackground={this.onSetBackground}
              />
            )}
          />
          <Route
            exact
            path="/photo/:id"
            render={routeProps => (
              <GalleryContainer
                {...routeProps}
                logo={logo}
                background={background}
                onSetLogo={this.onSetLogo}
                onSetBackground={this.onSetBackground}
              />
            )}
          />
          {/*<Route exact path="/" render={() => (loggedIn ? <Redirect to="/create_gallery/" /> : <PublicHomePage />)} />*/}
        </div>
      </BrowserRouter>
    );
  }
}

export default App;
